// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7d421e11","281":"9e2cf55f","339":"7e8d461e","374":"08cc10c5","390":"836c0d26","465":"90cfb630","510":"cdb6b5a1","569":"7a6adc94","643":"8967e4c2","846":"9bd73f29","886":"a2905bc9","914":"a0c3ef02"}[chunkId] + ".chunk.js";
};